import TitleView from './title-detail-view'

export default TitleView
